module.exports = __webpack_public_path__ + "static/donate_company_logo02@2x-be7f5ec28ef1c174797f5ba4cdb3ca77.png";